import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from 'axis-components/common-errors';
import { CompletedRequestComponent } from './completed-request/completed-request.component';
import { HomeComponent } from './home/home.component';
import { InsuredComponent } from './insured/insured.component';
import { PipConsentComponent } from './insured/pip/pip-consent/pip-consent.component';
import { PipNonDigitalElectionsComponent } from './insured/pip/pip-non-digital-elections/pip-non-digital-elections.component';
import { PipOutstandingStateSummaryComponent } from './insured/pip/pip-outstanding-state-summary/pip-outstanding-state-summary.component';
import { PipSelectionCoveragesComponent } from './insured/pip/pip-selection-coverages/pip-selection-coverages.component';
import { PipSignatureComponent } from './insured/pip/pip-signature/pip-signature.component';
import { PipStateSummaryComponent } from './insured/pip/pip-state-summary/pip-state-summary.component';
import { PipThankYouComponent } from './insured/pip/pip-thankyou/pip-thankyou.component';
import { PipPlaygroundComponent } from './playground/pip/pip-playground.component';
import { UimuiConsentComponent } from './insured/uim-ui/uimui-consent/uimui-consent.component';
import { UimuiNonDigitalElectionsComponent } from './insured/uim-ui/uimui-non-digital-elections/uimui-non-digital-elections.component';
import { UimuiOutstandingStateSummaryComponent } from './insured/uim-ui/uimui-outstanding-state-summary/uimui-outstanding-state-summary.component';
import { UimuiSelectionCoveragesComponent } from './insured/uim-ui/uimui-selection-coverages/uimui-selection-coverages.component';
import { UimuiSignatureComponent } from './insured/uim-ui/uimui-signature/uimui-signature.component';
import { UimuiStateSummaryComponent } from './insured/uim-ui/uimui-state-summary/uimui-state-summary.component';
import { UimuiThankYouComponent } from './insured/uim-ui/uimui-thankyou/uimui-thankyou.component';
import { InvalidatedRequestComponent } from './invalidated-request/invalidated-request.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { PlaygroundGuard } from './_core/guard/playground.gaurd';
import { UimuiPlaygroundComponent } from './playground/uimui/uimui-playground/uimui-playground.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
export const routes: Routes = [
  {
    path: 'broker',
    loadComponent: () =>
      import('./broker/broker-main/broker-main.component').then(
        (m) => m.BrokerMainComponent,
      ),
  },
  { path: '404', component: PageNotFoundComponent },
  { path: 'invalid', component: InvalidatedRequestComponent },
  { path: 'completed', component: CompletedRequestComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  {
    path: 'insured',
    component: InsuredComponent,
    children: [
      {
        path: 'uimui-consent',
        component: UimuiConsentComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:um_uim:consent',
            },
          },
        },
      },
      {
        path: 'uimui-selection',
        component: UimuiSelectionCoveragesComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:um_uim:selectionCoverages',
            },
          },
        },
      },
      {
        path: 'uimui-review-state',
        component: UimuiStateSummaryComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:um_uim:summaryState',
            },
          },
        },
      },
      {
        path: 'uimui-outstanding-state',
        component: UimuiOutstandingStateSummaryComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:um_uim:outstandingState',
            },
          },
        },
      },
      {
        path: 'uimui-signature',
        component: UimuiSignatureComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:um_uim:signature',
            },
          },
        },
      },
      {
        path: 'uimui-non-digital',
        component: UimuiNonDigitalElectionsComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:um_uim:nonDigital',
            },
          },
        },
      },
      {
        path: 'uimui-thankyou',
        component: UimuiThankYouComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:um_uim:thankYou',
            },
          },
        },
      },
      {
        path: 'uimui-playground',
        component: UimuiPlaygroundComponent,
        canActivate: [PlaygroundGuard],
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:uimui:playground',
            },
          },
        },
      },
      {
        path: 'pip-consent',
        component: PipConsentComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:consent',
            },
          },
        },
      },
      {
        path: 'pip-selection',
        component: PipSelectionCoveragesComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:selectionCoverages',
            },
          },
        },
      },
      {
        path: 'pip-review-state',
        component: PipStateSummaryComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:summaryState',
            },
          },
        },
      },
      {
        path: 'pip-outstanding-state',
        component: PipOutstandingStateSummaryComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:outstandingState',
            },
          },
        },
      },
      {
        path: 'pip-signature',
        component: PipSignatureComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:signature',
            },
          },
        },
      },
      {
        path: 'pip-non-digital',
        component: PipNonDigitalElectionsComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:nonDigital',
            },
          },
        },
      },
      {
        path: 'pip-thankyou',
        component: PipThankYouComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:thankYou',
            },
          },
        },
      },
      {
        path: 'pip-playground',
        component: PipPlaygroundComponent,
        canActivate: [PlaygroundGuard],
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:pip:playground',
            },
          },
        },
      },
      {
        path: 'home',
        component: HomeComponent,
        data: {
          adobeDataLayer: {
            page: {
              pageName: 'DigiSign:home',
            },
          },
        },
      },

      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      adobeDataLayer: {
        page: {
          pageName: 'DigiSign:Home:',
        },
      },
    },
  },
  {
    path: 'thank-you',
    component: ThankYouComponent,
    data: {
      adobeDataLayer: {
        page: {
          pageName: 'DigiSign:pip:thankYou',
        },
      },
    },
  },

  { path: '', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
